import SockJS from 'sockjs-client';
import { Stomp } from "@stomp/stompjs";

class WebSocketService {
    constructor() {
        this.stompClient = null;
        this.isConnected = false;
        this.userId = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 3000;
    }

    connect(userId, onMessageCallback) {
        if (this.isConnected) {
            console.warn("⚠️ WebSocket already connected");
            return;
        }

        this.userId = userId;

        // ✅ FIXED: Use production HTTPS URL instead of localhost
        const wsUrl = window.location.hostname === 'localhost'
            ? 'http://localhost:3453/ws-notifications'
            : 'https://api.community-hub.e-deeshatechnologies.com/ws-notifications';

        const socket = new SockJS(wsUrl);
        this.stompClient = Stomp.over(socket);
        this.stompClient.debug = () => {};

        const headers = {};

        this.stompClient.connect(headers, (frame) => {
            console.log('✅ WebSocket Connected:', frame);
            this.isConnected = true;
            this.reconnectAttempts = 0;

            this.stompClient.subscribe(
                `/user/${userId}/queue/notifications`,
                (message) => {
                    try {
                        const notification = JSON.parse(message.body);
                        console.log('📩 Real-time notification received:', notification);
                        if (onMessageCallback) {
                            onMessageCallback(notification);
                        }
                    } catch (e) {
                        console.error("❌ Error parsing notification:", e);
                    }
                }
            );

            this.stompClient.send('/app/register', {}, userId);
            console.log("✅ User registered for notifications");

        }, (error) => {
            console.error('❌ WebSocket Connection Error:', error);
            this.isConnected = false;
            this.handleConnectionError();
        });

        socket.onclose = () => {
            console.log('⚠️ WebSocket connection closed');
            this.isConnected = false;
        };
    }

    handleConnectionError() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            const delay = this.reconnectDelay * this.reconnectAttempts;
            console.log(`🔄 Attempting reconnection (${this.reconnectAttempts}/${this.maxReconnectAttempts}) in ${delay}ms...`);

            setTimeout(() => {
                if (!this.isConnected && this.userId) {
                    this.connect(this.userId, () => {});
                }
            }, delay);
        } else {
            console.error("❌ Max reconnection attempts reached. Please refresh the page.");
        }
    }

    disconnect() {
        if (this.stompClient && this.isConnected) {
            this.stompClient.disconnect(() => {
                console.log('✅ WebSocket disconnected gracefully');
                this.isConnected = false;
            });
        }
    }

    isWebSocketConnected() {
        return this.isConnected && this.stompClient !== null;
    }

    sendTestMessage(message) {
        if (this.stompClient && this.isConnected) {
            this.stompClient.send('/app/test', {}, message);
            console.log('📨 Test message sent:', message);
        } else {
            console.warn("⚠️ WebSocket not connected. Cannot send message.");
        }
    }

    getStatus() {
        return {
            isConnected: this.isConnected,
            userId: this.userId,
            reconnectAttempts: this.reconnectAttempts
        };
    }
}

const webSocketService = new WebSocketService();
export default webSocketService;